import styled from 'styled-components'

import { WaveIcon as WaveIconComponent } from '@presentation/assets/icons'
import { media } from '@presentation/styles'
export const Container = styled.header`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0.75rem;

  button {
    font-size: 1.1rem;
  }
`

export const Code = styled.h1`
  font-size: 7.8rem;
  font-weight: 700;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 0.75rem;
`

export const Title = styled.h2`
  font-size: 2.25rem;
  font-weight: 500;
  color: ${props => props.theme.colors.textPrimary};
  margin-bottom: 0.75rem;
`

export const Description = styled.p`
  font-size: 1.1rem;
  color: ${props => props.theme.colors.textPrimary};
  margin-bottom: 3rem;
`

export const WaveIcon = styled(WaveIconComponent)`
  display: none;
  position: absolute;
  left: 0;
  bottom: 0;
  height: 30vh;
  width: 100%;

  fill: ${props => props.theme.colors.primary};

  ${media.greaterThan('mobile')`
    display: block;
  `}
`
